import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Property } from '@vsolv/packages/properties/domain';
import { PropertyInputComponent } from '../abstract-property-input.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-boolean-input-field',
  templateUrl: './boolean-input.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: BooleanInputFieldComponent,
    },
    { provide: NG_VALIDATORS, useExisting: BooleanInputFieldComponent, multi: true },
  ],
})
export class BooleanInputFieldComponent extends PropertyInputComponent {
  @Input() override property!: Property.BooleanModel;

  /** Unique id for the checkbox so multiple boolean fields on the same page don't share IDs. */
  get checkboxId(): string {
    return `boolean-${this.property.id ?? this.property.valueKey}`;
  }
}
